import { Component, OnInit, Renderer2, ElementRef } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";

import { NotificationService } from "src/app/shared/services/utilities/notification.service";
import { NationalCodeValidatorService } from "src/app/shared/services/utilities/national-code-validator.service";
import { RadiographyResultModel } from "../../shared/models/radiography-result.model";
import { RadiographyService } from "../../shared/services/api-services/radiography.service";
import { RadiographySearchQueryModel } from "../../shared/models/radiography-search-query.model";
declare var $;

@Component({
  selector: "app-search-imaging-result",
  templateUrl: "./search-imaging-result.component.html",
  styleUrls: ["./search-imaging-result.component.scss"],
})
export class SearchImagingResultComponent implements OnInit {
  resultReady = false;
  resultMessage: string = null;
  imagingSearchForm: FormGroup;
  radiographyResultModel: RadiographyResultModel;
  recaptcha = new FormControl(false);
  isCaptchaLoaded = false;

  constructor(
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private radiographyService: RadiographyService,
    private nationalCodeValidatorService: NationalCodeValidatorService
  ) {}

  ngOnInit(): void {
    this.createImagingSearchForm();
  }

  createImagingSearchForm() {
    this.imagingSearchForm = this.formBuilder.group({
      nationalCode: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          this.nationalCodeValidatorService.nationalCodeValidator,
        ],
      ],
      privateId: ["", [Validators.required]],
      receptionNo: [
        "",
        [
          Validators.required,
          Validators.min(10000000),
          Validators.max(99999999),
        ],
      ],
    });
  }

  recaptchaLoaded() {
    this.isCaptchaLoaded = true;
  }

  recaptchaLoadError() {
    this.isCaptchaLoaded = false;
  }

  search() {
    this.resultReady = true;
    const query: RadiographySearchQueryModel = {
      nationalCode: this.imagingSearchForm.controls.nationalCode.value,
      receptionNo: this.imagingSearchForm.controls.receptionNo.value,
      privateId: this.imagingSearchForm.controls.privateId.value,
    };
    this.radiographyService.getRadiography(query).subscribe(
      (res) => {
        this.radiographyResultModel = res;
        if (this.radiographyResultModel == null) {
          this.notificationService.error(
            "خطا",
            "با مشخصات ورودی شما، رکوردی یافت نگردید"
          );
        }
        this.resultMessage = null;
      },
      (error) => {
        this.resultMessage = this.notificationService.showStrcturedError(
          error.error
        );
        this.radiographyResultModel = null;
        this.resultReady = false;
      },
      () => {
        this.resultReady = false;
      }
    );
  }

  printRadiography() {
    setTimeout(() => {
      $.print("#printBox-imaging");
    }, 100);
  }
}
